import { Observable, of } from 'rxjs';

import { Container, Service } from '../../../../symphony';

import { SlAIChatContext, SlAISolutionsContext } from '../../global-constants';
import { SlAIChatService } from '../Business/sl-ai-chat.service';
import { IActionData } from '../../global-interface';
import { SlTrackingService } from '../Business/sl-tracking.service';
import { SlAISolutionsService } from '../Business/sl-ai-solutions.service';

@Service()
export class SlActionsController {
	private aIChatService = Container.take(SlAIChatContext, SlAIChatService);

	private aISolutionsService = Container.take(
		SlAISolutionsContext,
		SlAISolutionsService,
	);

	private trackingService = Container.take(
		SlAIChatContext,
		SlTrackingService,
	);

	// UI events
	public messageSubmitButtonClickHandler = ({
		userMessage,
	}: IActionData): Observable<null> => {
		this.aIChatService.getAIResponse(userMessage);
		this.trackingService.trackSendMessage();
		return of(null);
	};

	public aIChatMountHandler = ({
		initialChatViewState,
		systemPromptId,
	}: IActionData): Observable<null> => this.aIChatService.handleAIChatMount(
		initialChatViewState,
		systemPromptId,
	);

	public expandClickHandler = (): Observable<null> => this.aIChatService.handleExpandClick();

	public hideClickHandler = (): Observable<null> => this.aIChatService.handleHideClick();

	public rateClickHandler = ({
		rating,
		messageId,
	}: IActionData): Observable<null> => this.aIChatService.handleRateClick(rating, messageId);

	public courseClickHandler = ({ alias }: IActionData): Observable<null> => this.aIChatService.handleCourseClick(alias);

	public aISolutionsMountHandler = (): Observable<null> => {
		this.aISolutionsService.handleAISolutionsMount();

		return of(null);
	};

	public aISolutionsDataUpdateHandler = ({
		materialHeader,
		codes,
		problem,
		session,
		solution,
		questionData,
		answerExplanationData,
		lessonContent,
		courseName,
		materialType,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionsDataUpdate(
		materialHeader,
		codes,
		problem,
		session,
		solution,
		questionData,
		answerExplanationData,
		lessonContent,
		courseName,
		materialType,
	);

	public aISolutionClickHandler = ({
		actionId,
		getSolutionClickSource,
		solutionContext,
	}: IActionData): Observable<null> => this.aISolutionsService.aISolutionClickHandler(
		actionId,
		getSolutionClickSource,
		solutionContext,
	);

	public aISolutionRateHandler = ({
		solutionId,
		solutionRating,
		solutionType,
		solutionContext,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionRate(
		solutionId,
		solutionRating,
		solutionType,
		solutionContext,
	);

	public aISolutionCollapseHandler = ({
		actionId,
		solutionContext,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionCollapse(
		actionId,
		solutionContext,
	);

	public aISolutionsCloseHandler = ({
		actionId,
		closeAISolutionsClickSource,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionsClose(
		actionId,
		closeAISolutionsClickSource,
	);

	public aISolutionsOpenHandler = ({
		solutionContext,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionsOpenHandler(
		solutionContext,
	);

	public getAIResponseInBottomSheetClickHandler = ({
		solutionContext,
	}: IActionData): Observable<null> => this.aISolutionsService.handleGetAIResponseInBottomSheetClick(
		solutionContext,
	);

	public aISolutionResponseCopyHandler = ({
		solutionContext,
		actionId,
	}: IActionData): Observable<null> => this.aISolutionsService.handleAISolutionResponseCopy(
		solutionContext,
		actionId,
	);

	// Business events
}
